import { takeLatest, all, put } from 'redux-saga/effects';
import UserActions from './user-actions';
import UserModel from './user-model';

function* fetchCurrentUserHandler() {
  try {
    const user = UserModel.create();
    yield put(UserActions.fetchCurrentUserSuccess(user));
  } catch (error) {
    yield put(UserActions.fetchCurrentUserFailure(error));
  }
}

export default function* userSagas() {
  yield all([takeLatest(UserActions.fetchCurrentUser.getType(), fetchCurrentUserHandler)]);
}
